module.exports = __webpack_public_path__ + "static/media/certi.a43bb21b.svg";